import { bool, oneOf, string } from 'prop-types'

import { PAGE_TYPES } from 'shared/consts/page'
import { shouldRenderNewLayout } from 'shared/experiments/components/NewSerp/helpers'
import ProductFilterVariant from 'shared/experiments/components/NewSerp/ProductFilterVariant'
import ProductFilter from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter'
import SearchContainerContent from 'views/components/organisms/AlgoliaInstantSearch/SearchContainerContent'
import CmsLayout from 'views/components/templates/CmsLayout'
import {
  downNavTreeType,
  navItemType,
  upNavTreeType,
} from 'views/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import './SearchResults.scss'

const SearchResults = ({
  hidden,
  indexName,
  infoText,
  logoPath,
  noveltiesIndexName,
  pageType,
  query,
  secondaryNavTitle,
  secondaryNavTree,
  title,
  topNav,
  upNavTree,
}) => {
  const { deviceClass } = usePublicConfig()

  return (
    <div className="o-SearchResults" aria-hidden={hidden ? 'true' : null}>
      {shouldRenderNewLayout({ deviceClass, pageType }) ? (
        <CmsLayout
          className="SearchResults--sidebarFlyout"
          title={title}
          logoPath={logoPath}
          topNav={topNav}
          upNavTree={upNavTree}
          secondaryNavTitle={secondaryNavTitle}
          secondaryNavTree={secondaryNavTree}
          infoText={infoText}
          pageType={pageType}
          slot={<ProductFilterVariant indexName={indexName} />}
        >
          <SearchContainerContent
            indexName={indexName}
            noveltiesIndexName={noveltiesIndexName}
            pageType={pageType}
            title={title}
            query={query}
          />
        </CmsLayout>
      ) : (
        <CmsLayout
          title={title}
          logoPath={logoPath}
          topNav={topNav}
          upNavTree={upNavTree}
          secondaryNavTitle={secondaryNavTitle}
          secondaryNavTree={secondaryNavTree}
          infoText={infoText}
          pageType={pageType}
          slot={<ProductFilter indexName={indexName} pageType={pageType} />}
        >
          <SearchContainerContent
            indexName={indexName}
            noveltiesIndexName={noveltiesIndexName}
            pageType={pageType}
            title={title}
            query={query}
          />
        </CmsLayout>
      )}
    </div>
  )
}

SearchResults.propTypes = {
  query: string.isRequired,
  pageType: oneOf(PAGE_TYPES),
  title: string,
  logoPath: string,
  topNav: navItemType,
  upNavTree: upNavTreeType,
  secondaryNavTitle: string,
  secondaryNavTree: downNavTreeType,
  infoText: string,
  indexName: string.isRequired,
  hidden: bool.isRequired,
  noveltiesIndexName: string,
}

SearchResults.defaultProps = {
  pageType: null,
  title: null,
  logoPath: null,
  topNav: null,
  upNavTree: [],
  secondaryNavTitle: null,
  secondaryNavTree: [],
  infoText: null,
  noveltiesIndexName: null,
}

export default SearchResults
